export default class CDNGeographicRestrictions {

  constructor() {
    this.form = document.getElementById('cdn_update_geographic_restrictions');
    const self = this;

    if (this.form) {
      const restrictionTypeInputRadios = this.form.querySelectorAll('.form-check-input');
      if (restrictionTypeInputRadios.length) {
        for (const input of restrictionTypeInputRadios) {
          if (input.checked) {
            this.onRestrictionTypeChange(input.value)
          }

          input.addEventListener('change', (event) => {
            self.onRestrictionTypeChange(event.target.value)
          })
        }
      }

      window.deleteGeoLocation = options => {
        self.onDeleteCountryFromList(options.country, this.form)
      }
    }
  }

  onRestrictionTypeChange(value) {
    const countryPicker = this.form.querySelector('#cdn_update_geographic_restrictions_countries');
    const parent = countryPicker.closest('.form-group');
    if (value === 'none') {
      countryPicker.disabled = true;
      parent.classList.add('d-none')
    } else {
      countryPicker.disabled = false;
      parent.classList.remove('d-none')
    }
  }

  onDeleteCountryFromList(country, form) {
    const deletedLocationInput = form.querySelector('#cdn_update_geographic_restrictions_deleted_locations');
    const inputValue = JSON.parse(deletedLocationInput.value || '[]');
    inputValue.push(country);
    deletedLocationInput.value = JSON.stringify(inputValue);

    const countriesTable = document.querySelector('#grid_cdn_geographic_restrictions');
    const rows = countriesTable.querySelectorAll('tbody tr');
    for (const row of rows) {
      const buttonExists = row.querySelector(`.location_${ country }`);
      if (buttonExists) row.remove()
    }
  }
}
